module.exports = __webpack_public_path__ + "img/bee-line-rev.04f373eb.png";